import SnapshotPreview from './SnapshotPreview';

export default SnapshotPreview;
export * from './types';

export { SnapshotPreview };
